import { render, staticRenderFns } from "./create-product.vue?vue&type=template&id=d5db6b5a&scoped=true&"
import script from "./create-product.vue?vue&type=script&lang=js&"
export * from "./create-product.vue?vue&type=script&lang=js&"
import style0 from "./create-product.vue?vue&type=style&index=0&id=d5db6b5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5db6b5a",
  null
  
)

export default component.exports